/**
 * Client-safe helper: first alternate ID whose type is in idTypes.
 * Logic matches encamp-shared findAlternateId for the shape used by templates (type, value only).
 * Kept local to avoid pulling encamp-shared into the Oak ESM/Rollup bundle (CJS interop issues).
 */
export function findAlternateId(ids, idTypes) {
    if (ids.length === 0 || idTypes.length === 0) {
        return undefined;
    }
    return ids.find((x) => idTypes.includes(x.type));
}
//# sourceMappingURL=findAlternateId.js.map